import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

//import redux related
import {Provider} from 'react-redux';
import store from './store';

store.firebaseAuthIsReady
    .then(()=>{
        ReactDOM.render(
            <Provider store={store}>
                <App />
            </Provider>,
            document.getElementById('root'));
    })




// WEBPACK FOOTER //
// ./src/index.js